var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper"},[_c('div',{class:_vm.size + '-' + _vm.typeLowercase + (_vm.filled ? '-filled' : '') + '-icon'})])}
var staticRenderFns = []

export { render, staticRenderFns }